module.exports = __webpack_public_path__ + "static/media/icon-error.c53e93e5.svg";